<script>

</script>

<footer id="footer">
    <p>Frederik Behrens</p>
    <img id="logo" src="./assets/logo.png" alt="Frederik Behrens's Logo"> 
    <p><a href="mailto:frederikbehrens90@gmail.com">frederikbehrens90@gmail.com</a></p>
</footer> 

<style>
    #logo {
        height: 40px;
        width: 40px;
    }

    #footer {
        color: rgba(0, 0, 0, 0.7);;
        background-color: #fff;
        text-decoration: none;
        padding-top: 24px;
        padding-bottom: 24px;
        padding-left: 48px;
        padding-right: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        bottom: 0;
        border-top: 5px solid rgba(0, 0, 0, 0.9);
    }

    #footer a {
        text-decoration: none;
    }

    @media (max-width: 952px) {
        #footer {
            flex-direction: column;
        }
    }
</style>